module.exports = __webpack_public_path__ + "img/logo.dafcbed0.png";